import axios, { extractData, getAccountSuggestions, getParentAccountSuggestions } from '@atheneum/api'
import { computed, extendObservable } from 'mobx'
import moment from 'moment'


class DraftedInvoicesStore {
  constructor (staticData) {
    const defaultInvoiceStatus = { id: '', name: 'All' }

    extendObservable(this, {
      loading: false,
      error: null,
      staticData,
      invoices: [],
      noOfInvoices: null,
      currentInvoiceStatus: defaultInvoiceStatus,
      query: this.getEmptyQuery(),
      invoiceStatuses: computed(() => {
        const { CREATED } = this.staticData.CONST.INVOICE_STATUSES
        const invoiceStatuses = this.staticData.invoiceStatuses.filter(
          status => status.id < CREATED
        )
        return [defaultInvoiceStatus, ...invoiceStatuses]
      }),
      parentAccountSuggestion: '',
      accountSuggestion: ''
    })
  }

  getEmptyQuery () {
    return {
      type: 'drafted',
      page: 1,
      limit: 20,
      invoicingEntity: '',
      invoiceNo: '',
      parentAccount: '',
      account: '',
      invoiceStatus: '',
      startDate: moment()
        .startOf('month')
        .format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    }
  }

  filter () {
    this.loading = true
    const url = '/api/invoice/invoice-listing'
    return axios
      .post(url, this.query)
      .then(res => {
        const responseData = extractData(res)
        this.noOfInvoices = responseData.count
        this.invoices.replace(responseData.invoices)
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  autocompleteParentAccount = value => {
    if (!value) return Promise.resolve([])

    return getParentAccountSuggestions(value).then(result => {
      const autocompleteResult = result.map(element => {
        const suggestion = {
          value: element.id,
          label: element.parentAccountName
        }
        return suggestion
      })
      return autocompleteResult
    })
  }

  autocompleteAccount = value => {
    if (!value) return Promise.resolve([])

    return getAccountSuggestions(value).then(result => {
      const autocompleteResult = result.map(element => {
        const suggestion = {
          value: element.id,
          label: element.companyName
        }
        return suggestion
      })
      return autocompleteResult
    })
  }

  changePage (page) {
    this.query.page = page
    this.filter()
  }

  clearSearch () {
    this.query = this.getEmptyQuery()
    this.parentAccountSuggestion = ''
    this.accountSuggestion = ''
    this.currentInvoiceStatus = { id: '', name: 'All' }
    this.filter()
  }
}

export default DraftedInvoicesStore
